// API coordinates may be numbers or numeric strings; zero is a valid location.
export function hasValidCoordinates(coordinates: { latitude: unknown; longitude: unknown } | null | undefined): boolean {
    const valid = (value: unknown, limit: number): boolean => {
        if (typeof value !== 'number' && typeof value !== 'string') return false;
        if (typeof value === 'string' && !value.trim()) return false;
        const number = Number(value);
        return Number.isFinite(number) && Math.abs(number) <= limit;
    };
    return !!coordinates && valid(coordinates.latitude, 90) && valid(coordinates.longitude, 180);
}
